import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { E_FLOW_HEX } from '../../../constants';
import { createPortCode } from '../../../utils';
export const DOT_ENERGY_CONFIG = {
    type: ERFElement.DotEnergy,
    templates: [
        {
            code: 'single',
            ports: [
                {
                    id: createPortCode('target', 'energy'),
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 7, left: 0, background: E_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: createPortCode('source', 'energy'),
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 7, right: 0, background: E_FLOW_HEX },
                    connectionCount: 1
                }
            ]
        },
        {
            code: 'multi',
            ports: [
                {
                    id: createPortCode('target', 'energy'), // Входные энергетические потоки
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 7, left: 0, background: E_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: createPortCode('source', 'energy'), // Выходные энергетические потоки
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 7, right: 0, background: E_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFDotEnergyNode.config.js.map